import { render, staticRenderFns } from "./productHeader.vue?vue&type=template&id=086395ac&"
import script from "./productHeader.vue?vue&type=script&lang=js&"
export * from "./productHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports